<span class="user">{{data.comment.user.display_name}}</span>
<span class="content">{{data.comment.content}}</span>